"use strict";

(function ($, win, doc) {
  if (!$ || typeof $.fn.slick !== "function") return;
  const reduceMotion =
    typeof win.matchMedia === "function" &&
    win.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /** Align the clicked tab with the left edge of the horizontal `.tabs__list` strip. */
  /** @param {Element | null | undefined} tabEl */
  function scrollTabStripToTabLeft(tabEl) {
    if (!tabEl || typeof tabEl.closest !== "function") return;
    var strip = tabEl.closest('[role="tablist"]');
    if (!strip || strip.scrollWidth <= strip.clientWidth + 1) return;

    var tabRect = tabEl.getBoundingClientRect();
    var stripRect = strip.getBoundingClientRect();
    var padLeft =
      parseFloat(win.getComputedStyle(strip).paddingLeft || "0") || 0;

    var delta = tabRect.left - stripRect.left - padLeft;
    var target = strip.scrollLeft + delta;
    var maxScroll = Math.max(0, strip.scrollWidth - strip.clientWidth);
    target = Math.max(0, Math.min(target, maxScroll));

    strip.scrollTo({
      left: target,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  }

  /** @param {JQuery<Element>} $slider */
  function initPolTabSlider($slider) {
    if (!$slider.length || $slider.hasClass("slick-initialized")) return;

    var $wrap = $slider.closest(".tab-sliders");
    var $prev = $wrap.find(".js-pol-tab-slider-prev");
    var $next = $wrap.find(".js-pol-tab-slider-next");

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      speed: reduceMotion ? 0 : 280,
      arrows: false,
      prevArrow: $prev.length ? $prev : undefined,
      nextArrow: $next.length ? $next : undefined,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            arrows: Boolean($prev.length && $next.length),
          },
        },
      ],
    });
  }

  /** @param {JQuery<Element>} $panels */
  /** @param {JQuery<Element>} $shown */
  function syncPanelVisibility($panels, $shown) {
    $panels.each(function () {
      var $panel = $(this);
      var on = this === $shown[0];
      var $track = $panel.find(".js-pol-tab-slider");

      if (on) {
        $panel.removeAttr("hidden").attr("aria-hidden", "false");
        initPolTabSlider($track);
        win.requestAnimationFrame(function () {
          if ($track.hasClass("slick-initialized")) $track.slick("setPosition");
        });
      } else {
        $panel.attr("hidden", "").attr("aria-hidden", "true");
        if ($track.hasClass("slick-initialized")) $track.slick("slickGoTo", 0, true);
      }
    });
  }

  $(function () {
    $(".js-pol-tabs").each(function () {
      var $root = $(this);
      var $tabs = $root.find('[role="tab"]');
      var $panels = $root.find('[role="tabpanel"]');

      $tabs.on("click", function () {
        var $btn = $(this);
        if ($btn.attr("aria-selected") === "true") return;
        var targetId = $btn.attr("aria-controls");
        if (!targetId) return;
        var $panel = $(doc.getElementById(targetId));
        if (!$panel.length) return;

        $tabs.attr("aria-selected", "false").attr("tabindex", "-1");
        $btn.attr("aria-selected", "true").attr("tabindex", "0");

        syncPanelVisibility($panels, $panel);
        win.requestAnimationFrame(function () {
          scrollTabStripToTabLeft($btn[0]);
        });
      });

      $tabs.on("keydown", function (evt) {
        var i = $tabs.index(this);
        var max = $tabs.length - 1;
        var nextIndex = null;
        if (evt.key === "ArrowRight" || evt.key === "ArrowDown")
          nextIndex = Math.min(max, i + 1);
        else if (evt.key === "ArrowLeft" || evt.key === "ArrowUp")
          nextIndex = Math.max(0, i - 1);
        else if (evt.key === "Home") nextIndex = 0;
        else if (evt.key === "End") nextIndex = max;

        if (nextIndex === null || nextIndex === i) return;
        evt.preventDefault();
        $($tabs[nextIndex]).focus().trigger("click");
      });

      $panels.each(function () {
        if (!$(this).prop("hidden"))
          initPolTabSlider($(this).find(".js-pol-tab-slider"));
      });
    });
  });
})(typeof jQuery !== "undefined" ? jQuery : null, window, document);
